// extracted by mini-css-extract-plugin
export default {"pageWrapper":"AboutPage_pageWrapper__Nq1zR","progressNav":"AboutPage_progressNav__tw0Vg","visible":"AboutPage_visible__CavKg","contentArticle":"AboutPage_contentArticle__Ft9rK"};